module.exports = __webpack_public_path__ + "d6a126506276688d5ec4a0bb69e18d8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/help/help-webchat.png
// module id = 460
// module chunks = 0